interface ScriptToLoad {
  id: string
  src: string
  dataset?: Record<string, string>
}

const waitForScript = (script: HTMLScriptElement) =>
  new Promise<boolean>((resolve) => {
    script.addEventListener('load', () => resolve(true))
    script.addEventListener('error', () => resolve(false))
  })

const addScript = ({ id, src, dataset = {} }: ScriptToLoad) => {
  const script = document.createElement('script')
  script.id = id
  script.src = src
  script.async = true
  Object.assign(script.dataset, dataset)
  document.head.appendChild(script)
  return script
}

// Resolves false when the script is blocked or offline: that provider's button then stays hidden.
export const loadScript = (scriptToLoad: ScriptToLoad): Promise<boolean> => {
  const existing = document.getElementById(scriptToLoad.id)
  const script =
    existing instanceof HTMLScriptElement ? existing : addScript(scriptToLoad)
  return waitForScript(script)
}
